import { MaskedLine, Overline } from "@/components/Reveal";

export default function PageHero({ overline, title, subtitle }) {
  return (
    <section className="bg-navy text-cream relative grain" data-testid="page-hero">
      <div className="relative z-10 mx-auto max-w-7xl px-6 lg:px-10 pt-40 pb-24">
        <Overline dark>{overline}</Overline>
        <h1 className="mt-6 font-serif text-5xl sm:text-6xl font-medium tracking-tight leading-[1.05] max-w-4xl">
          <MaskedLine>{title}</MaskedLine>
        </h1>
        {subtitle && (
          <p className="mt-6 text-lg text-cream/70 max-w-2xl leading-relaxed">{subtitle}</p>
        )}
      </div>
    </section>
  );
}
